define('models/ContactModel',['underscore', 'ObjectModel', 'LocalStorage', 'ApiRequest', 'app'], function (_, ObjectModel, LocalStorage, ApiRequest, app) {
    //
    // Model Contact
    //

    var iconMap = {
        "20":"icon-cart",
        "6":"icon-favorite",
        "7":"icon-comein",
        "8":"icon-screen",
        "19":"icon-phone",
        "15":"icon-book",
        "13":"icon-user",
        "11":"icon-chat"
        }, 
        defaultIcon = "icon-customer-service";

    var ContactModelPrototype = {

        name: 'ContactModel',
        idAttribute: 'id_contact',
        route: 'apiContactModel',

        defaults:{
            id_contact:'new'
        },

        initialize: function () {
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);
            //
        },


        getName:function () {
            return this.get('name');
        },
        getLinkRewrite:function () {
            return this.get('link_rewrite');
        },
        submit: function (email,
                          commandeId,
                          storeId,
                          lastName,
                          firstName,
                          postCode,
                          city,
                          phone,
                          message) {

            var model = this, options = {
                email: email,
                commandeId: commandeId,
                storeId: storeId,
                lastName: lastName,
                firstName: firstName,
                postCode: postCode,
                city: city,
                phone: phone,
                message: message
            };

            //model.set(options);

            model.save(options, {
                success: function(mod, response) {
                    app.bottomNotice(app.t('Demande envoyée', 'Contact'));
                    app.trigger('contactSuccessReset')
                },
                error: function(mod, response) {
                    app.bottomNotice(response.responseJSON.error);
                    app.trigger('contactFailReset')
                },
                wait: true
            });

        },
        getIcon:function(){
            // TODO static ids mapping
            var icon = iconMap[this.id];
            if(!icon){icon = defaultIcon}
            return icon;
        }
    };

    var ContactModel = ObjectModel.extend(LocalStorage).extend(ContactModelPrototype);

    return ContactModel;
});
